import { Component, h } from "preact";
import { IReactConfiguration } from "../../typings";

export default class Message extends Component<IMessageProps> {
  render(): JSX.Element {
    const element: HTMLElement = document.querySelector(
      this.props.conf.messageTarget,
    );
    if (!this.props.message) {
      element.innerHTML = "";
      return <span />;
    }

    element.innerHTML =
      '      <ul class="messages">' +
      '        <li class="message message--error">' +
      '          <svg class="icon icon--error" role="img">' +
      "            <title>error</title>" +
      '            <use xlinkHref="' +
      this.props.conf.asset_prefix +
      '/assets/img/icons-sprite.svg#error" />' +
      "          </svg>" +
      this.props.message +
      '          <svg class="icon icon--close js-close-message" role="img" viewBox="0 0 64 64">' +
      "            <title>close</title>" +
      '            <use xlinkHref="/images/icons-sprite.svg#close" />' +
      "          </svg>" +
      "        </li>" +
      "      </ul>";

    return <span />;
  }
}

interface IMessageProps {
  message: string;
  conf: IReactConfiguration;
}
